import { gql } from "apollo-boost"

export const getDashboardsTotals = gql`
  query getSubmissions ($where: DashboardSubmissionsWhere!){
    SubmissionsToApprove(where: $where){
      regionalCount
      multiRegionalCount
    },
    SubmissionsCreated(where: $where),
    SubmissionsRejected(where: $where),
    AmountByStrategicAxis(where:$where){
      strategicAxis
      totalAmount
      count
    }
  }
`